import React from "react";
import { Row, Col, Card, Alert } from "react-bootstrap";
import { object, string, func, bool } from "prop-types";
import infoIcon from "resources/images/circle-info-green.png";
import { workplaceInsightsTraitMap } from "../constants";
import { renderDownloadButton } from "../renderHelpers";

const WorkplaceInsightsSection = ({
  candidateFirstName,
  handleDownloadPdf,
  showWorkplaceInsightsTraits,
  workplaceInsightsData,
}) => {
  const TraitBoxes = [];

  if (
    showWorkplaceInsightsTraits &&
    workplaceInsightsData.get("candidateTraits")
  ) {
    workplaceInsightsData
      .get("candidateTraits")
      .valueSeq()
      .forEach((trait) => {
        TraitBoxes.push(
          <Col lg={6} key={trait}>
            <Card
              className="py-2 px-4 mb-4"
              style={{
                borderLeft: `4px solid ${workplaceInsightsTraitMap[trait][2]}`,
                borderRadius: "0px",
              }}
            >
              <h4
                className="font-weight-bold mb-0 criteria-navy-color"
                style={{
                  fontSize: "14px",
                  marginTop: "4px",
                }}
              >
                {workplaceInsightsTraitMap[trait][0]}
              </h4>
              <p style={{ color: "#53565a" }}>
                {workplaceInsightsTraitMap[trait][1]}
              </p>
            </Card>
          </Col>
        );
      });
  }

  const DownloadButton = (
    <span
      className="text-right"
      style={{
        width: "170px",
      }}
    >
      {renderDownloadButton(
        handleDownloadPdf,
        null,
        "Workplace Insights Report",
        !showWorkplaceInsightsTraits
      )}
    </span>
  );

  return (
    <Card className="px-3 pt-4 mt-4">
      <Col>
        <Row className="d-flex justify-content-between mx-1">
          <h2 className="font-weight-bold" style={{ fontSize: "20px" }}>
            Workplace Insights Report
          </h2>
          {showWorkplaceInsightsTraits && DownloadButton}
        </Row>
        <p className="pt-3 pb-2">
          {`This score report is intended to be shared with the test-taker, and
          be used in a post-hire setting for the purpose of enhancing self-awareness,
          and encouraging growth and development. If the candidate agrees, it may also
          be shared with ${candidateFirstName}'s team members, manager and/or direct reports,
          if appropriate, so that new team members may become aware of ${candidateFirstName}'s
          likely work styles and how their behavioral tendencies may influence interactions
          with team members in the workplace.`}
        </p>
        {showWorkplaceInsightsTraits ? (
          <div>
            <h3
              className="font-weight-bold criteria-navy-color"
              style={{ fontSize: "18px" }}
            >
              Notable Traits
            </h3>
            <p style={{ color: "#53565a" }}>
              <em>{candidateFirstName} can be described as:</em>
            </p>
            <Row>{TraitBoxes}</Row>
          </div>
        ) : (
          <Alert
            variant="info"
            className="d-flex justify-content-between"
            style={{ padding: "12px 14px" }}
          >
            <div className="d-flex" style={{ marginTop: "5px" }}>
              <img
                height="16px"
                width="16px"
                src={infoIcon}
                alt="Info"
                className="mr-3"
              />
              <p className="mb-0">
                {`Download this candidate's Workplace Insights Report to view more.`}
              </p>
            </div>
            {DownloadButton}
          </Alert>
        )}
      </Col>
    </Card>
  );
};

WorkplaceInsightsSection.propTypes = {
  candidateFirstName: string,
  handleDownloadPdf: func.isRequired,
  showWorkplaceInsightsTraits: bool,
  workplaceInsightsData: object,
};

export default WorkplaceInsightsSection;
